import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

/** Restores an archived work package to the state it was archived in. */
export const unarchiveProject = api(async function unarchiveProject({ projectId }) {
    return mutate(
        gql`
            mutation UnarchiveProject($projectId: String!) {
                unarchiveProject(projectId: $projectId) {
                    success
                    error
                }
            }
        `,
        { projectId },
        { returns: "unarchiveProject" }
    )
})
